// extracted by mini-css-extract-plugin
export default {"list":"bCNiT5V4dNGBpRLaS3KK","tab":"lVUu4edfAwIuPcIYgpkG"};